import React, { useEffect, useMemo, useState } from 'react';

import {
  EuiDatePicker
} from '@elastic/eui';
import { useStateApp } from '../../../../ui/src/context/StateAppContext';
import moment from 'moment';
import { CreateFechaMoment } from '../../../utils/fecha';

const SelectorFecha = (props) => {

  const {haveBlockDates} = props
  const {currentSettingsApp} = useStateApp()
  const [datesBlocked, setDatesBlocked]=useState([]);

  const isValidDates = useMemo(()=> currentSettingsApp!==undefined && currentSettingsApp===null && currentSettingsApp.fechaBloqueoParcialDesde!==null 
  && currentSettingsApp.fechaBloqueoParcialHasta!==null ,[currentSettingsApp])

  useEffect(()=>{
    if((haveBlockDates !== undefined || haveBlockDates === true) && isValidDates)
    {
      var a = CreateFechaMoment(currentSettingsApp.fechaBloqueoParcialDesde);
      var b = CreateFechaMoment(currentSettingsApp.fechaBloqueoParcialHasta);
      let dates = []

      for (var m = moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
        const newDate = CreateFechaMoment(m.format('DD/MM/YYYY'))
        dates.push(newDate);
      }
      setDatesBlocked([...dates])
    }
  },[haveBlockDates, currentSettingsApp])

  return (
          <EuiDatePicker
            dateFormat="DD-MM-YYYY"
            locale="es-es"
            excludeDates={datesBlocked}
            {...props}
          />
  );
};

export default SelectorFecha;